import { ActionMap, createMsg } from 'src/core/engine/actionCreators';

import { ResolvedComponent } from '../utils/resolve';

import { scrollTopEpic } from './epics/windowScrollTop.epic';
import { serviceWorkerEpic } from './epics/serviceWorker.epic';
import { onlineOffLineEpic } from './epics/onlineOffline.epic';
import { reloadEpic } from './epics/reload.epic';

export enum RuntimeActions {
    SetResolving = 'Runtime/SetResolving',
    SetResolve = 'Runtime/SetResolve',
    Log = 'Runtime/Log',
    SetOutdated = 'Runtime/SetOutdated',
    SetOnline = 'Runtime/SetOnline',
    Reload = 'Runtime/Reload',
    ScrollTop = 'Runtime/ScrollTop',
    SetEnv = 'Runtime/SetEnv',
}

export type RuntimeEnv = {
    NODE_ENV: 'production' | 'development';
    REDUX_STORE_TOOLS: boolean;
    SERVICE_WORKER: boolean;
    RELEASE_STAGE: 'local' | 'develop' | 'staging' | 'production';
    VERSION: string;
    DOMAIN: string;
};

export type RuntimeState = {
    online: boolean;
    outdated: boolean;
};

export const initialState: RuntimeState = {
    online: true,
    outdated: false,
};

export type Messages = {
    [RuntimeActions.SetResolving]: boolean;
    [RuntimeActions.SetResolve]: ResolvedComponent;
    [RuntimeActions.Log]: any[];
    [RuntimeActions.SetOutdated]: undefined;
    [RuntimeActions.SetOnline]: boolean;
    [RuntimeActions.Reload]: undefined;
    [RuntimeActions.ScrollTop]: { duration: number; selector: string };
};

export const RuntimeMsg = createMsg<Messages>();
export type TypeMap = ActionMap<Messages>;
export type Handler = TypeMap[keyof TypeMap];
export type Actions = Handler;
export type AppendState<T = {}> = T & { runtime: RuntimeState };

export function runtimeReducer(state = initialState, action: Handler): RuntimeState {
    switch (action.type) {
        case RuntimeActions.SetOutdated: {
            return {
                ...state,
                outdated: true,
            };
        }
        case RuntimeActions.SetOnline: {
            return {
                ...state,
                online: action.payload,
            };
        }
        default:
            return state;
    }
}

export function registerRuntime() {
    return {
        epics: [scrollTopEpic, serviceWorkerEpic, onlineOffLineEpic, reloadEpic],
        reducers: {
            runtime: runtimeReducer,
        },
        name: 'runtime',
    };
}
